import VerifiedUserOutlinedIcon from "@material-ui/icons/VerifiedUserOutlined";
import { CreateFmcsaDataTransfer } from "./CreateFmcsaDataTransfer";
import { FmcsaDataTransferList } from "./FmcsaDataTransferList";
import { ViewFmcsaDataTransfer } from "./ViewFmcsaDataTransfer";

export default {
  icon: VerifiedUserOutlinedIcon,
  list: FmcsaDataTransferList,
  create: CreateFmcsaDataTransfer,
  show: ViewFmcsaDataTransfer,
};
